module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gy-f3e2f1acb06c7b8bd851e6cc047c13ce.svg";